'use client';

import { cn } from '@ui/lib/utils';

interface ComboboxItemSkeletonProps {
  className?: string;
  withImage?: boolean;
  withRemoveButton?: boolean;
}

export function ComboboxItemSkeleton({
  className,
  withImage = true,
  withRemoveButton = true,
}: ComboboxItemSkeletonProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-1 rounded-full bg-white py-0.5 pl-1 pr-1 shadow-sm text-slate-800 text-sm ring-1 ring-inset ring-slate-200 animate-pulse',
        className
      )}
    >
      {withImage && (
        <div className="h-6 w-6 flex-shrink-0 rounded-full bg-slate-200"></div>
      )}
      <div className="flex items-center gap-1 w-full max-w-[100px]">
        <div className="h-4 bg-slate-200 rounded w-full"></div>
      </div>
      {withRemoveButton && (
        <div className="rounded-full p-0.5 h-4 w-4 bg-slate-200"></div>
      )}
    </div>
  );
}

export function ComboboxOptionsSkeleton({
  count = 3,
  className,
}: {
  count?: number;
  className?: string;
}) {
  return (
    <div className={cn('space-y-1.5 p-1.5', className)}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center px-2 py-1.5 gap-2 animate-pulse"
        >
          <div className="bg-slate-200 rounded-full h-6 w-6"></div>
          <div className="bg-slate-200 rounded-lg h-4 w-32"></div>
        </div>
      ))}
    </div>
  );
}
